import {Modal, ModalProps} from '@/components/app/modal';
import {useContext} from 'react';
import {useGetBiobookPagesQuery} from '../../../app/services/biobookApi';
import {PersonContext} from '../../person/contexts/PersonContext';
import {Icon} from '../../../app/components/Icon';
import {BiobookPage} from '../../biobook/components/BiobookPage';
import {InfoSection} from '../../../app/components/InfoSection';
export interface ToolDetailsDialogProps extends ModalProps {
  labelId?: number;
}
export const ToolDetailsDialog = ({labelId = -1, open, ...otherProps}: ToolDetailsDialogProps) => {
  const {userId} = useContext(PersonContext);
  const {data: toolBiobookPages, isFetching: isFetchingGetBiobookPages} = useGetBiobookPagesQuery(
    {
      labelId,
    },
    {
      skip: !labelId,
    },
  );
  return (
    <Modal
      title={'Biobook Pages'}
      style={{
        maxWidth: 'calc(100vw - 3rem)',
        width: '48rem',
      }}
      open={open}
      {...otherProps}
    >
      {isFetchingGetBiobookPages && (
        <div className={'flex items-center justify-center h-full'}>
          <Icon icon={'spinner'} spin />
        </div>
      )}
      {!isFetchingGetBiobookPages && (
        <div className={'flex flex-col gap-4'}>
          {toolBiobookPages
            ?.filter((biobookPage, i, a) => a.findIndex((b) => b.phraseId === biobookPage.phraseId) === i)
            .map((biobookPage) => (
              <BiobookPage biobookPage={biobookPage} key={biobookPage.phraseId} userId={userId} />
            ))}
        </div>
      )}
      {!isFetchingGetBiobookPages && !toolBiobookPages?.length && (
        <InfoSection
          className={'h-full'}
          icon={'ban'}
          message={'There is currently no available page to display for this tool.'}
          title={'No Pages'}
        />
      )}
    </Modal>
  );
};
